import React from 'react'
import { Student } from '../interfaces/ModuleTypes'

const StudentContext = React.createContext({
    currentStudent: {} as Student,
    setCurrentStudent: (student: Student) => { }
})

export default StudentContext
